import { styled, Paper as PaperMui } from "@material-ui/core";

export const Paper = styled(PaperMui)({
  flexGrow: 1,
  maxWidth: "33.5625rem",
  margin: "0 auto",
  borderRadius: 0
});
